/**
 * Normalise un numéro pour l'appel via tel: link.
 * Convertit +33 / 0033 → 0 (France). Un numéro étranger reste au format international (+32…) : le convertir en « 0… »
 * composait un numéro FRANÇAIS, donc une autre personne (vu à la relecture du 31/10/2026).
 * Garde l'affichage d'origine intact — ne touche que le href.
 *
 * Préfixes de sortie du standard (décision William 31/10/2026) : on compose un chiffre AVANT le numéro pour choisir
 * le numéro présenté — 0 = METERIS (01 83 62 33 27), 1 = MCF (01 85 84 03 20), 2 = atelier (01 84 74 44 95).
 * `phoneToDialable(numero, prefixe)` l'ajoute devant un numéro FRANÇAIS à 10 chiffres ; un numéro étranger, un poste
 * interne ou un numéro déjà préfixé restent tels quels. Le chiffre à utiliser vient de `usePrefixeAppel`.
 */
export const PREFIXES_APPEL = Object.freeze({ meteris: '0', mcf: '1', atelier: '2' });

export const LIGNES_APPEL = Object.freeze({
  0: { nom: 'METERIS', numero: '01 83 62 33 27' },
  1: { nom: 'MCF', numero: '01 85 84 03 20' },
  2: { nom: 'atelier', numero: '01 84 74 44 95' },
});

const DEJA_PREFIXE = /^[012]0[1-9]\d{8}$/;
const NATIONAL = /^0[1-9]\d{8}$/;

export function phoneToDialable(phone, prefixe = '') {
  if (!phone) return '';
  // Mêmes séparateurs et mêmes formes que le serveur (numero_client_svc.numero_a_composer) : le chiffre affiché et le
  // chiffre composé ne doivent jamais diverger. « +33 (0)1… » et un numéro à 9 chiffres (0 de tête oublié) sont français.
  const clean = String(phone).replace(/[\s\-./()]/g, '');
  if (DEJA_PREFIXE.test(clean)) return clean;
  const national = (reste) => (reste.startsWith('0') ? reste : '0' + reste);
  let francais = false;
  let out = clean;
  if (clean.startsWith('+33')) { out = national(clean.slice(3)); francais = true; }
  else if (clean.startsWith('0033')) { out = national(clean.slice(4)); francais = true; }
  else if (/^[1-9]\d{8}$/.test(clean)) { out = '0' + clean; francais = true; }
  else francais = NATIONAL.test(clean);
  if (francais && prefixe && Object.prototype.hasOwnProperty.call(LIGNES_APPEL, prefixe) && NATIONAL.test(out)) {
    return prefixe + out;
  }
  return out;
}

/** Le chiffre que le lien ajoute VRAIMENT à ce numéro ('' si aucun : déjà préfixé, étranger, poste interne…). Le badge
 *  n'affiche que celui-là : il ne doit jamais annoncer un chiffre que l'appel ne compose pas. */
export function chiffreAjoute(phone, prefixe) {
  if (!prefixe) return '';
  return phoneToDialable(phone, prefixe) !== phoneToDialable(phone) ? String(prefixe) : '';
}
